import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { Dropdown, Button, Input, Form, Icon} from 'semantic-ui-react'
import { Translate, LanguageContext } from '../../helpers/language';

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: this.props.query ? this.props.query: '', historyLink: true};

    this.handleChange = this.handleChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleRef = this.handleRef.bind(this);
  }

  componentDidMount () {
    this.setState({historyLink: true});
  }

  componentWillReceiveProps(nextProps) {    
    if (nextProps.query) {
      this.setState({value: nextProps.query});
    }
  }

  handleRef = (c) => {
    this.inputRef = c
  }

  handleChange(event) {
    this.setState({value: event.target.value});
    if (this.props.handleSearchQueryChanged)
      this.props.handleSearchQueryChanged(event);
  }

  handleClear(event) {
    event.preventDefault();
    this.setState({value: ''});
    this.inputRef.focus();
  }

  render(){
    return (
      <Col className="searchBarWrapper" xs={12}>
        <Form onSubmit={this.props.do_search.bind(this)}>
          <Row between="xs" >
            <Col xs={11}  >
              <Input
                fluid
                iconPosition='left'
                onChange={(e) => this.handleChange(e)}
                className='searchBarInput'
                placeholder={Translate(this.context,'search_ask_me_something')}
                ref={this.handleRef} >                
                {typeof this.state.value !== 'undefined' && this.state.value.length > 0 ? <Icon name='x' size='large' link  onClick={(e) => this.handleClear(e)} className='searchIconCustom'/> : <Icon name='search' size='large' className='searchIconCustom'/> }
                <input className='textInputCustom' value={this.state.value} />
              </Input>
            </Col>
            <Col className='pull_right' xs={1}>
              <Button
                type="submit"
                icon='chevron right'
                circular
                size='large'
                className='lisia-blue-search searchButton'
                disabled={this.state.value == ''}/>
            </Col>                
          </Row>
        </Form>        
      </Col>       
    )
  }

}

SearchBar.contextType = LanguageContext;

SearchBar.propTypes = {
  value: PropTypes.string,
  do_search: PropTypes.func,  
  handleSearchQueryChanged: PropTypes.func,
}

export default SearchBar
